import { useTranslation } from 'react-i18next';
import { UserCompanyRole } from '@monorepo/shared';

interface UserRoleBadgeProps {
  role: UserCompanyRole;
}

const getRoleBadgeClass = (role: UserCompanyRole) => {
  switch (role) {
    case UserCompanyRole.SUPER_ADMIN:
      return 'bg-red-100 text-red-800';
    case UserCompanyRole.SUPER_USER:
      return 'bg-orange-100 text-orange-800';
    case UserCompanyRole.VALIDATOR:
      return 'bg-green-100 text-green-800';
    case UserCompanyRole.USER:
      return 'bg-gray-100 text-gray-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const UserRoleBadge = ({ role }: UserRoleBadgeProps) => {
  const { t } = useTranslation();

  const getRoleLabel = () => {
    switch (role) {
      case UserCompanyRole.SUPER_ADMIN:
        return t('admin.users.table.status.super_admin');
      case UserCompanyRole.SUPER_USER:
        return t('admin.users.table.status.super_user');
      case UserCompanyRole.VALIDATOR:
        return t('admin.users.table.status.validator');
      case UserCompanyRole.USER:
        return t('admin.users.table.status.user');
      default:
        return role;
    }
  };

  return (
    <span
      className={`px-3 py-1 inline-flex text-xs leading-5 font-medium rounded-full ${getRoleBadgeClass(role)}`}
    >
      {getRoleLabel()}
    </span>
  );
};
